module.exports = __webpack_public_path__ + "static/media/icon.da2c83d9.png";